export default "__VITE_ASSET__544bfac0__"